import React, { useState } from 'react';
import classNames from 'classnames';
import Image from 'next/image';

import { Button, TabContent, TabContentItem, TabPanel, Tabs } from '..';
import Tab from '../Tabs/Tab';

import styles from './Company.module.scss';

const Company = ({ data }) => {
  const [activeTab, setActiveTab] = useState(0);

  const renderTab = (item, key) => (
    <Tab
      className={classNames([
        styles.tab,
        { [styles.active]: activeTab === key },
      ])}
      onClick={() => setActiveTab(key)}
      key={key}
    >
      {item.title}
    </Tab>
  );

  const renderTabContent = (item, key) => {
    const tabData = item?.items?.[0] || {};

    return (
      <TabContentItem
        className={classNames({
          [styles.tabContentItem]: activeTab === 0,
        })}
        key={key}
        itemScope
        itemType='https://schema.org/Article'
      >
        <div className={styles.info}>
          <h2 className={styles.title}>{tabData?.title}</h2>
          <p className={styles.text}>{tabData?.content}</p>

          <Button href={tabData?.slug} Component={'router'} size='big'>
            <span style={{ marginRight: '10px' }}>{tabData?.button_text}</span>{' '}
            <Image
              src='/assets/ArrowRightDark.svg'
              alt='arrow'
              title='Arrow'
              width={16}
              height={16}
            />
          </Button>
        </div>
      </TabContentItem>
    );
  };
  const curentTab = data?.tabs[activeTab]?.items[0];
  return (
    <div
      className={`${styles.companyBlock} wrapper section`}
      itemScope
      itemType='https://schema.org/Organization'
    >
      <div className={styles.note}>{curentTab?.name}</div>
      {!!data?.tabs?.length && (
        <Tabs active={activeTab}>
          <TabPanel className={styles.tabToggles}>
            {data?.tabs.map(renderTab)}
          </TabPanel>
          <TabContent>{data?.tabs.map(renderTabContent)}</TabContent>
        </Tabs>
      )}
    </div>
  );
};

export default Company;
